import CloseoutIcon from '../parts/CloseoutIcon'
import { PrintType } from '@/features/print/constants'
import KitchenIcon from '@/features/ui/icons/components/KitchenIcon'
import ReceiptIcon from '@/features/ui/icons/components/ReceiptIcon'
import ScooterIcon from '@/features/ui/icons/components/ScooterIcon'

export const getIcon = (printType: PrintType) => {
    switch (printType) {
        case PrintType.KitchenBons:
            return KitchenIcon
        case PrintType.Receipts:
            return ReceiptIcon
        case PrintType.DeliveryTickets:
            return ScooterIcon
        case PrintType.ShiftCloseouts:
            return CloseoutIcon
    }
}
